export default "__VITE_ASSET__DrxXjz_y__"